import React, { InputHTMLAttributes, ReactNode } from 'react';
import { motion } from 'framer-motion';

interface InputFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  icon?: ReactNode;
  rightElement?: ReactNode;
  error?: string;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  icon,
  rightElement,
  error,
  className = '',
  ...props
}) => {
  return (
    <div className="w-full">
      {label && (
        <label 
          htmlFor={props.id} 
          className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
        >
          {label}
        </label>
      )}
      
      <div className="relative">
        {icon && (
          <div className="absolute inset-y-0 start-0 ps-3 flex items-center pointer-events-none text-gray-500 dark:text-gray-400">
            {icon}
          </div>
        )}
        
        <input
          className={`
            w-full 
            px-4 py-3 
            ${icon ? 'ps-10' : ''} 
            ${rightElement ? 'pe-10' : ''} 
            bg-gray-50 dark:bg-gray-700 
            border border-gray-300 dark:border-gray-600 
            text-gray-900 dark:text-white 
            rounded-lg 
            focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent
            placeholder:text-gray-400 dark:placeholder:text-gray-500
            disabled:opacity-60 disabled:cursor-not-allowed
            ${error ? 'border-red-500 focus:ring-red-500' : ''}
            ${className}
          `}
          {...props}
        />
        
        {rightElement && (
          <div className="absolute inset-y-0 end-0 pe-3 flex items-center">
            {rightElement}
          </div>
        )}
      </div>
      
      {error && (
        <motion.p 
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="mt-1 text-sm text-red-600 dark:text-red-500"
        >
          {error}
        </motion.p>
      )}
    </div>
  );
};

export default InputField;